module.exports = __webpack_public_path__ + "img/cover.129ef2f4.jpg";